export default __webpack_public_path__ + "static/media/witten2.9a338798.png";